module.exports = __webpack_public_path__ + "img/bekabeling_1.3dd1708e.png";